<template>
    <ol>
        <li v-for="entry in tree" :key="entry.id">
            <view-entry
                :entry="entry"
                :schedule="schedule"
                :metas="metas"
                :groups="groups"
                :show-advanced="showAdvanced"
                :mass-create="massCreate"
                :select-color="selectColor"
                :calculated-name="calculatedName"
                @booked="emit('booked')"
                @dialog:open="emit('dialog:open')"
                @dialog:close="emit('dialog:close')"
            ></view-entry>

            <view-tree
                v-if="entry.children && entry.children.length > 0"
                :tree="entry.children"
                :schedule="schedule"
                class="lg:pl-10"
                :metas="metas"
                :groups="groups"
                :show-advanced="showAdvanced"
                :mass-create="massCreate"
                :select-color="selectColor"
                :calculated-name="calculatedName"
                @booked="emit('booked')"
                @dialog:open="emit('dialog:open')"
                @dialog:close="emit('dialog:close')"
            ></view-tree>
        </li>
    </ol>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import ViewEntry from '@src/Reservations/Pages/Schedule/ViewEntry.vue';

interface Props {
    tree?: any[];
    schedule?: {
        from: string | null;
        to: string | null;
        group: string;
    };
    metas?: {
        [key: string]: string;
    } | null;
    groups?: any[] | object;
    showAdvanced?: boolean;
    selectColor?: boolean;
    massCreate?: boolean;
    calculatedName?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    tree: () => [],
    schedule: () => ({
        from: null,
        to: null,
        group: 'day',
    }),
    metas: null,
    groups: () => [],
    showAdvanced: false,
    selectColor: false,
    massCreate: false,
    calculatedName: false,
});

const emit = defineEmits(['booked', 'dialog:open', 'dialog:close']);

const tree = toRef(props, 'tree');
const schedule = toRef(props, 'schedule');
const metas = toRef(props, 'metas');
const groups = toRef(props, 'groups');
</script>
